import { makeStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import { IconZoomIn, IconZoomOut } from '../../../base/icons/svg';
import useShareScreenController from './useShareScreenController';
import { useSelector } from 'react-redux';
import { getScreenShareWheelEvent } from '../../../sharescreen-moderation/functions';
const useStyles = makeStyles()(theme => {
    return {
        controlGroup: {
            display: "flex"
        },
        zoomButton: {
            cursor: 'pointer',
            borderRadius: '50%',
            padding: '3px',
            transition: '.2s',
            '&:hover': {
                background: theme.palette.default01
            }
        },
        scale: {
            margin: '0px 3px'
        }
    };
});
export default function ShareScreenController() {
    const { controllable, zoomOut, zoomIn, onWheel, scale } = useShareScreenController();
    const localShareWheelEvent = useSelector(getScreenShareWheelEvent);
    const { classes, cx } = useStyles();
    const handleZoomOut = (_) => {
        zoomOut();
    };
    const handleZoomIn = (_) => {
        zoomIn();
    };
    useEffect(() => {
        if (localShareWheelEvent && controllable) {
            onWheel(localShareWheelEvent);
        }
    }, [localShareWheelEvent, controllable]);
    return (React.createElement("div", null, controllable && (React.createElement("div", null, controllable && (React.createElement("div", { className: classes.controlGroup },
        React.createElement("div", { className: classes.zoomButton, onClick: handleZoomOut },
            React.createElement(IconZoomOut, null)),
        React.createElement("span", { className: classes.scale },
            scale,
            "%"),
        React.createElement("div", { className: classes.zoomButton, onClick: handleZoomIn },
            React.createElement(IconZoomIn, null))))))));
}
